<template>
  <div class="content">
    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="优惠券名称">
            <el-input v-model="search.name" maxlength="30" placeholder="请输入优惠券名称" />
          </el-form-item>
          <el-form-item label="优惠券类型">
            <el-select v-model="search.type" class="w120" clearable placeholder="请选择优惠券类型">
              <el-option
                v-for="item in options.type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券状态">
            <el-select v-model="search.status" clearable class="w120" placeholder="请选择优惠券状态">
              <el-option label="未开始" :value="0" />
              <el-option label="进行中" :value="1" />
              <el-option label="已过期" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="领取方式">
            <el-select v-model="search.is_publicize" clearable class="w120" placeholder="请选择领取方式">
              <el-option label="中台发放" :value="0" />
              <el-option label="小程序领取" :value="1" />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <div class="accountCon">
      <el-button v-if="userInfo.id == 444 || userInfo.id == 1" type="primary" class="mb10" size="mini" @click="tapBtn('one')" v-loading.fullscreen.lock="fullscreenLoading">一键发券</el-button>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            @selection-change="handleSelectionChange"
          >
            <ElTableColumn type="index" width="50" />
            <ElTableColumn label="优惠券名称" prop="name" />
            <ElTableColumn label="优惠券类型" prop="type" width="100" />
            <ElTableColumn label="适用类型" prop="" width="100">
              <template slot-scope="{ row }">
                <span v-if="row.use_type == 1">商品</span>
                <span v-if="row.use_type == 2">服务</span>
                <span v-if="row.use_type == 3">品项</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="领取方式" prop="is_publicize_desc" width="100">
              <template slot-scope="{ row }">
                <span v-if="row.is_publicize == 0">中台发放</span>
                <span v-if="row.is_publicize == 1">小程序领取</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="面值(元)" prop="denomination" width="150" />
            <ElTableColumn label="优惠券状态" prop="status_desc" width="100" />
            <ElTableColumn label="发放状态" prop="provide_status_desc" width="100" />
            <ElTableColumn label="有效期" width="200">
              <template slot-scope="{ row }">
                <div>{{ row.start_time }} 至 {{ row.end_time }}</div>
              </template>
            </ElTableColumn>
            <ElTableColumn label="创建时间" prop="create_time" />
            <ElTableColumn label="领取数量" prop="receive_count" />
            <ElTableColumn label="订单数量" prop="order_count" />
            <ElTableColumn label="实收总额" prop="order_amount_sum" />
            <ElTableColumn label="实收赠金" prop="gift_amount_sum" />
            <ElTableColumn label="实收本金" prop="pay_amount_sum" />
            <ElTableColumn label="店转" prop="shop_transfer_amount_sum" />
            <ElTableColumn label="创建人" prop="create_user_name" />
            <ElTableColumn label="创建门店" prop="shop_names" />
            <ElTableColumn label="操作" fixed="right" width="220">
              <template slot-scope="{ row }">
                <el-button
                  v-if="row.is_publicize == 1 && row.status != 2"
                  type="text"
                  style="margin-right: 5px;"
                  @click="openQrCodeDialog(row)"
                >
                  推广
                </el-button>
                <el-button type="text" @click="tapBtn('detail', row.id)">查 看</el-button>
                <el-button
                  v-if="row.create_user_id == userInfo.id"
                  type="text"
                  :disabled="row.status == 2 || row.provide_status == 1"
                  @click="tapBtn('update', row.id)"
                >
                  编 辑
                </el-button>
                <el-button
                  type="text mr10"
                  :disabled="row.status == 2"
                  @click="tapBtn('issue', row.id, row.shop_id)"
                >
                  发 放
                </el-button>
                <span
                  class="peril"
                  type="text"
                  v-if="row.create_user_id == userInfo.id"
                  @click="tapBtn('del', row.id)"
                >
                  删 除
                </span>
                <el-button type="text" @click="openShortUrlDialog(row)" v-if="row.is_publicize == 1">上传短链接</el-button>
              </template>
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>

    <!-- 二维码弹窗 -->
    <el-dialog
      title="推广优惠券"
      :visible.sync="qrCodeDialog.visible"
      width="800px"
      :close-on-click-modal="false"
      @close="closeQrCodeDialog"
    >
      <div class="qr-code-container">
        <div class="qr-code-item">
          <div class="qr-code-wrapper" :class="{ loading: qrCodeDialog.signLoading }">
            <div v-if="qrCodeDialog.signLoading" class="skeleton">
              <i class="el-icon-loading"></i>
              <span>加载中...</span>
            </div>
            <img
              v-else-if="qrCodeDialog.signImg"
              :src="qrCodeDialog.signImg"
              alt="二维码"
              class="qr-code-image"
              @error="handleImageError('sign')"
            />
            <div v-else class="skeleton error">
              <i class="el-icon-warning"></i>
              <span>加载失败</span>
            </div>
          </div>
          <div class="qr-code-label">二维码</div>
          <div class="qr-code-actions">
            <el-button
              type="primary"
              size="small"
              :disabled="!qrCodeDialog.signImg"
              @click="downloadQrcode('sign')"
            >
              下载二维码
            </el-button>
          </div>
        </div>

        <div class="qr-code-divider"></div>

        <div class="qr-code-item">
          <div class="qr-code-wrapper" :class="{ loading: qrCodeDialog.spreadLoading }">
            <div v-if="qrCodeDialog.spreadLoading" class="skeleton">
              <i class="el-icon-loading"></i>
              <span>加载中...</span>
            </div>
            <img
              v-else-if="qrCodeDialog.spreadImg"
              :src="qrCodeDialog.spreadImg"
              alt="小程序码"
              class="qr-code-image"
              @error="handleImageError('spread')"
            />
            <div v-else class="skeleton error">
              <i class="el-icon-warning"></i>
              <span>加载失败</span>
            </div>
          </div>
          <div class="qr-code-label">小程序码</div>
          <el-button
            type="primary"
            size="small"
            :disabled="!qrCodeDialog.spreadImg"
            @click="downloadQrcode('spread')"
          >
            下载小程序码
          </el-button>
        </div>
        <div class="qr-code-divider"></div>
        <div class="qr-code-item">
          <div>长链接：{{ qrCodeDialog.urlLink }}</div>
          <el-button
            type="primary"
            size="mini"
            style="width: 100px;"
            :disabled="!qrCodeDialog.urlLink"
            @click="copyURLLink"
          >
            复制链接
          </el-button>
          <div>中转长链接：{{ qrCodeDialog.zShortUrlLink }}</div>
          <el-button
            type="primary"
            size="mini"
            style="width: 100px;"
            :disabled="!qrCodeDialog.zShortUrlLink"
            @click="copyZShortURLLink"
          >
            复制链接
          </el-button>
          <div v-if="qrCodeDialog.shortUrlLink">短链接：{{ qrCodeDialog.shortUrlLink }}</div>
          <el-button
            v-if="qrCodeDialog.shortUrlLink"
            type="primary"
            size="mini"
            style="width: 100px;"
            :disabled="!qrCodeDialog.shortUrlLink"
            @click="copyShortURLLink"
          >
            复制短链接
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 发放结果弹窗 -->
    <el-dialog title="发放结果" :visible.sync="sendCause" :close-on-click-modal="false" width="600px">
      <el-table
        :data="sendCauseRes"
        style="width: 100%"
        size="small"
        border
      >
        <el-table-column
          prop="name"
          label="优惠券"
          min-width="120"
        />
        <el-table-column
          prop="vipType"
          label="会员等级"
          min-width="100"
        />
        <el-table-column
          prop="should_send"
          label="应发人数"
          width="90"
          align="center"
        />
        <el-table-column
          prop="actual_send"
          label="实际发放"
          width="90"
          align="center"
        />
        <el-table-column
          prop="cause"
          label="原因"
          min-width="150"
        />
      </el-table>
    </el-dialog>

    <!-- 上传短链接弹窗 -->
    <el-dialog
      title="上传短链接"
      :visible.sync="shortUrlDialog.visible"
      width="520px"
      :close-on-click-modal="false"
      @close="closeShortUrlDialog"
    >
      <el-form
        ref="shortUrlForm"
        :model="shortUrlDialog"
        :rules="shortUrlRules"
        label-width="90px"
        size="small"
      >
        <el-form-item label="优惠券名称">
          <span class="form-label">{{ shortUrlDialog.couponName }}</span>
        </el-form-item>
        <el-form-item label="短链接" prop="shortUrl">
          <el-input
            v-model="shortUrlDialog.shortUrl"
            placeholder="请输入短链接"
            clearable
          >
          </el-input>
        </el-form-item>
        <div class="dialog-tip">
          <i class="el-icon-info"></i>
          <span>短链接用于优惠券推广，请确保链接地址有效</span>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeShortUrlDialog">取 消</el-button>
        <el-button type="primary" size="small" :loading="shortUrlDialog.submitting" @click="submitShortUrl">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from "@/components/Pagination";
import {
  getCardList,
  deleteCard,
  cardexport,
  oneProvide,
  getCardQrcode,
  generateCouponQRCode,
  generateCouponURLLink,
  updateShortUrl,
  ZgenerateCouponURLLink
} from "@/api/card";

class Page {
  total = 0;
  page = 1;
  limit = 10;
}

class Search {
  name = "";
  type = "";
  status = "";
  is_publicize = "";
}

class Options {
  constructor() {
    this.type = [
      { id: 1, name: "满减券" },
      { id: 3, name: "满赠券" },
      { id: 4, name: "兑换券" }
    ];
  }
}

export default {
  name: "CardList",
  components: {
    pagination
  },
  data() {

    return {
      search: new Search(),
      options: new Options(),
      page: new Page(),
      list: [],
      sendCauseRes: [],
      idList: [],
      fullscreenLoading: false,
      sendCause: false,

      // 二维码弹窗状态
      qrCodeDialog: {
        visible: false,
        signImg: "",
        spreadImg: "",
        urlLink: "",
        signLoading: false,
        spreadLoading: false,
        currentId: null,
        signError: false,
        spreadError: false,
        shortUrlLink: "",
        zShortUrlLink: "",
      },

      // 上传短链接弹窗状态
      shortUrlDialog: {
        visible: false,
        couponId: null,
        couponName: '',
        shortUrl: '',
        submitting: false,
      },

      // 短链接表单校验规则
      shortUrlRules: {
        shortUrl: [
          { required: true, message: '请输入短链接', trigger: 'blur' },
        ]
      },

      // 表格样式
      cellStyle: {
        padding: '8px 0'
      },
      headerCellStyle: {
        background: '#f5f7fa',
        color: '#606266',
        fontWeight: 600,
        padding: '10px 0'
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  mounted() {
    this.getList();
  },
  methods: {
    // ==================== 短链接弹窗相关 ====================

    // 打开上传短链接弹窗
    openShortUrlDialog(row) {
      // 重置表单
      this.shortUrlDialog = {
        visible: true,
        couponId: row.id,
        couponName: row.name || '未命名优惠券',
        shortUrl: '',
        submitting: false,
      };

      if (row.url_link) {
        this.shortUrlDialog.shortUrl = row.url_link;
      }

      // 重置表单校验
      this.$nextTick(() => {
        if (this.$refs.shortUrlForm) {
          this.$refs.shortUrlForm.clearValidate();
        }
      });
    },

    // 关闭上传短链接弹窗
    closeShortUrlDialog() {
      this.shortUrlDialog.visible = false;
      if (this.$refs.shortUrlForm) {
        this.$refs.shortUrlForm.resetFields();
      }
    },

    // 提交短链接
    submitShortUrl() {
      this.$refs.shortUrlForm.validate((valid) => {
        if (!valid) return;

        this.shortUrlDialog.submitting = true;

        updateShortUrl({
          id: this.shortUrlDialog.couponId,
          url_link: this.shortUrlDialog.shortUrl
        })
          .then(res => {
            this.$message.success(res.msg || '短链接上传成功');
            this.closeShortUrlDialog();
            this.getList(); // 刷新列表
          })
          .catch(error => {
            this.$message.error(error.msg || '上传短链接失败，请重试');
          })
          .finally(() => {
            this.shortUrlDialog.submitting = false;
          });
      });
    },

    // ==================== 二维码弹窗相关 ====================

    // 下载 base64 图片
    downloadBase64(dataUrl, fileName) {
      try {
        let imageData = dataUrl;
        if (!dataUrl.startsWith('data:image')) {
          imageData = `data:image/png;base64,${dataUrl}`;
        }

        const link = document.createElement("a");
        link.href = imageData;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('下载成功');
      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('下载失败，请重试');
      }
    },

    // 下载二维码
    downloadQrcode(type) {
      const imgSrc = type === "sign" ? this.qrCodeDialog.signImg : this.qrCodeDialog.spreadImg;
      if (!imgSrc) {
        this.$message.warning('图片未加载完成');
        return;
      }
      const fileName = type === "sign" ? "二维码.png" : "小程序码.png";
      this.downloadBase64(imgSrc, fileName);
    },

    // 图片加载错误处理
    handleImageError(type) {
      if (type === 'sign') {
        this.qrCodeDialog.signError = true;
        this.qrCodeDialog.signImg = '';
      } else {
        this.qrCodeDialog.spreadError = true;
        this.qrCodeDialog.spreadImg = '';
      }
    },

    // 打开二维码弹窗
    async openQrCodeDialog(row) {
      this.qrCodeDialog.visible = true;
      this.qrCodeDialog.currentId = row.id;
      this.qrCodeDialog.shortUrlLink = row.url_link;

      this.qrCodeDialog.signImg = "";
      this.qrCodeDialog.spreadImg = "";
      this.qrCodeDialog.urlLink = "";
      this.qrCodeDialog.zShortUrlLink = "";
      this.qrCodeDialog.signLoading = true;
      this.qrCodeDialog.spreadLoading = true;
      this.qrCodeDialog.signError = false;
      this.qrCodeDialog.spreadError = false;

      try {
        const results = await Promise.allSettled([
          getCardQrcode({ id: row.id }),
          generateCouponQRCode({ id: row.id }),
          generateCouponURLLink({ id: row.id }),
          ZgenerateCouponURLLink({ id: row.id })
        ]);

        if (results[0].status === 'fulfilled') {
          this.qrCodeDialog.signImg = results[0].value;
        } else {
          console.error('获取二维码失败:', results[0].reason);
          this.qrCodeDialog.signError = true;
        }

        if (results[1].status === 'fulfilled') {
          this.qrCodeDialog.spreadImg = results[1].value;
        } else {
          console.error('获取小程序码失败:', results[1].reason);
          this.qrCodeDialog.spreadError = true;
        }

        if (results[2].status === 'fulfilled') {
          this.qrCodeDialog.urlLink = results[2].value;
        } else {
          console.error('获取推广链接失败:', results[2].reason);
        }
        if (results[3].status === 'fulfilled') {
          this.qrCodeDialog.zShortUrlLink = results[3].value;
        } else {
          console.error('获取中转长链接失败:', results[3].reason);
        }
      } catch (error) {
        console.error('加载二维码失败:', error);
        this.$message.error('加载二维码失败，请重试');
      } finally {
        this.qrCodeDialog.signLoading = false;
        this.qrCodeDialog.spreadLoading = false;
      }
    },

    // 关闭二维码弹窗
    closeQrCodeDialog() {
      this.qrCodeDialog.currentId = null;
      this.qrCodeDialog.signImg = "";
      this.qrCodeDialog.spreadImg = "";
      this.qrCodeDialog.urlLink = "";
      this.qrCodeDialog.zShortUrlLink = "";
    },

    // 复制推广链接
    copyURLLink() {
      if (!this.qrCodeDialog.urlLink) {
        this.$message.warning('链接未加载完成');
        return;
      }
      this.copyToClipboard(this.qrCodeDialog.urlLink);
    },

    // 复制短链接
    copyShortURLLink() {
      if (!this.qrCodeDialog.shortUrlLink) {
        this.$message.warning('短链接未加载完成');
        return;
      }
      this.copyToClipboard(this.qrCodeDialog.shortUrlLink);
    },
     copyZShortURLLink() {
      if (!this.qrCodeDialog.zShortUrlLink) {
        this.$message.warning('短链接未加载完成');
        return;
      }
      this.copyToClipboard(this.qrCodeDialog.zShortUrlLink);
    },
    // 通用复制方法
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text)
          .then(() => this.$message.success('复制成功'))
          .catch(() => this.copyByInput(text));
      } else {
        this.copyByInput(text);
      }
    },

    // 通过 input 复制（兼容方案）
    copyByInput(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      document.body.removeChild(input);
    },

    // ==================== 列表相关 ====================

    getList(option) {
      if (option === "search") this.page.page = 1;
      getCardList({ ...this.search, ...this.page }).then(res => {
        this.list = res.list || [];
        this.page.total = res.dataCount || 0;
      }).catch(error => {
        console.error('获取列表失败:', error);
        this.$message.error('获取列表失败');
      });
    },

    tapBtn(type, id, shop_id) {
      switch (type) {
        case "detail":
          this.$router.push("./cardDetail?id=" + id);
          break;
        case "update":
          this.$router.push("./addCard?id=" + id);
          break;
        case "issue":
          this.$router.push("./issueCard?id=" + id + "&shop_id=" + shop_id);
          break;
        case "del":
          this.hint(id, "删除此优惠券");
          break;
        case "export":
          this.hint("export", "导出选中列表");
          break;
        case "one":
          this.hint("one", "一键发放会员券");
          break;
      }
    },

    hint(type, text) {
      this.$confirm(`${text}，是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type == "export") {
            this.getExport();
          } else if (type == "one") {
            this.sendCard();
          } else {
            this.delCard(type);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    getExport() {
      if (!this.idList || this.idList.length === 0) {
        this.$message.warning('请先选择要导出的数据');
        return;
      }
      cardexport({ id: this.idList }).then(res => {
        if (res.url) {
          window.open(res.url);
        }
      }).catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出失败');
      });
    },

    handleSelectionChange(val) {
      this.idList = val.map(i => i.id);
    },

    delCard(id) {
      deleteCard({ id: id }).then(res => {
        this.$message({
          type: "success",
          message: res.msg || "删除成功"
        });
        this.getList();
      }).catch(error => {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      });
    },

    sendCard() {
      this.fullscreenLoading = true;
      oneProvide({}).then(res => {
        this.sendCauseRes = res.data || [];
        this.sendCause = true;
      }).catch(error => {
        console.error('一键发放失败:', error);
        this.$message.error('一键发放失败');
      }).finally(() => {
        this.fullscreenLoading = false;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.bgW {
  background: #fff;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.el-form-item {
  margin: 5px 30px 3px 0;

  &:last-child {
    margin-right: 0;
  }
}

.accountCon {
  background: #fff;
  padding: 15px 20px 80px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.mb10 {
  margin-bottom: 15px;
}

.w120 {
  width: 120px;
}

.operation-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: center;
}

.el-button--text {
  font-size: 12px;
}

.peril {
  color: #f56c6c;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 12px;
  border-radius: 3px;
  transition: all 0.3s;

  &:hover {
    background: #fef0f0;
    opacity: 0.8;
  }
}

.el-table {
  border-radius: 4px;
  overflow: hidden;

  ::v-deep {
    .el-table__header-wrapper {
      .el-table__header {
        th {
          background: #f5f7fa !important;
          color: #606266;
          font-weight: 600;
        }
      }
    }

    .el-table__body-wrapper {
      .el-table__body {
        td {
          padding: 8px 0;
        }
      }
    }

    .el-table__fixed {
      box-shadow: -2px 0 6px rgba(0, 0, 0, 0.06);
    }
  }
}

// ==================== 二维码弹窗样式 ====================
.qr-code-container {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 10px 0;
  gap: 20px;
}

.qr-code-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.qr-code-wrapper {
  width: 180px;
  height: 180px;
  border-radius: 8px;
  overflow: hidden;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ebeef5;
  flex-shrink: 0;
  transition: all 0.3s;

  &.loading {
    border-color: #409eff;
  }
}

.qr-code-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-code-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  letter-spacing: 1px;
}

.qr-code-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.qr-code-divider {
  width: 1px;
  height: 220px;
  background: #ebeef5;
  flex-shrink: 0;
}

.skeleton {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  color: #909399;
  gap: 8px;
  font-size: 13px;

  .el-icon-loading {
    font-size: 32px;
    color: #409eff;
    animation: rotating 1.2s linear infinite;
  }

  &.error {
    .el-icon-warning {
      font-size: 32px;
      color: #e6a23c;
    }
    span {
      color: #909399;
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// ==================== 短链接弹窗样式 ====================
.form-label {
  color: #303133;
  font-size: 13px;
  line-height: 32px;
  display: inline-block;
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.old-url {
    color: #909399;
    font-size: 12px;
  }
}

.dialog-tip {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 10px 12px;
  background: #f4f4f5;
  border-radius: 4px;
  margin-top: 5px;

  .el-icon-info {
    color: #909399;
    font-size: 14px;
    margin-top: 1px;
    flex-shrink: 0;
  }

  span {
    color: #909399;
    font-size: 12px;
    line-height: 1.6;
  }
}

::v-deep {
  .el-dialog {
    border-radius: 12px;

    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #ebeef5;

      .el-dialog__title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .el-dialog__body {
      padding: 20px;
    }

    .el-dialog__footer {
      padding: 10px 20px 20px;
    }
  }
}

// ==================== 移动端适配 ====================
@media (max-width: 768px) {
  .bgW {
    padding: 10px 15px;
  }

  .accountCon {
    padding: 10px 15px 60px;
  }

  .el-form-item {
    margin: 5px 15px 3px 0;
  }

  .operation-buttons {
    flex-direction: column;
    align-items: center;
    gap: 2px;
  }

  .qr-code-container {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  .qr-code-divider {
    width: 80%;
    height: 1px;
  }

  .qr-code-wrapper {
    width: 150px;
    height: 150px;
  }

  .qr-code-actions {
    flex-direction: column;
    align-items: center;
    width: 100%;

    .el-button {
      width: 100%;
    }
  }

  ::v-deep {
    .el-dialog {
      width: 95% !important;
      margin: 20px auto !important;
    }
  }
}

// ==================== 打印样式 ====================
@media print {
  .el-button,
  .peril,
  .operation-buttons {
    display: none !important;
  }

  .el-table {
    border: 1px solid #ddd;
  }
}
</style>